import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import FooterTopBoxes from '~/components/common/FooterTopBoxes.js';
import DoubleBanner from '~/components/home/DoubleBanner';
import HeroSlider from '~/components/home/HeroSlider';
import HomepageMotto from '~/components/home/HomepageMotto';
import Instagram from '~/components/home/Instagram.js';
import { clearHistoryStateAction } from '~/store/actions.js';
// import News from '~/components/home/News.js';
import ProductTabs from '~/components/home/ProductTabs';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import PageHeaderMeta from '~/components/common/PageHeaderMeta';
import BannerGroups from '~/components/home/BannerGroups.js';
import QuadPuzzleBanner from '~/components/home/QuadPuzzleBanner.js';
import espaBanner from '~/images/espa2023.jpg';

export default function Home() {
	const dispatch = useDispatch();
	const { t } = useTranslation();

	useEffect(() => {
		dispatch(clearHistoryStateAction());

		var header_el = window.document.getElementsByTagName('header')[0];
		header_el.classList.add('home-header');

		window.onscroll = function () {
			if (document.documentElement.scrollTop > 0) {
				header_el.classList.remove('home-header');
			} else {
				if (!header_el.classList.contains('home-header')) {
					header_el.classList.add('home-header');
				}
			}
		};

		return () => {
			window.onscroll = null;
			header_el.classList.remove('home-header');
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<PageHeaderMeta
				page_title={t('seo_title_home')}
				meta_description={t('seo_description_home')}
				meta_keywords={t('seo_keywords_home')}
			/>

			<div id="main-wrapper home">
				<main id="homepage">
					<div className="espa-banner">
						<Link to={'pages/epixeirhsiako-programma-antagonistikothta-epixeirhmatikothta-kainotomia'}>
							<img src={espaBanner} alt="Espa Banner" />
						</Link>
					</div>
					<HeroSlider />
					<QuadPuzzleBanner />
					<BannerGroups />
					<ProductTabs />
					<DoubleBanner />
					<HomepageMotto />
					<Instagram />
					{/* <News /> */}
					<FooterTopBoxes />
				</main>
			</div>
		</>
	);
}
